import React from "react";
import {SurveySectionRenderingComponent, SurveySectionsRenderingModel} from "data/models/survey/base";
import {TitleComponent} from "components/Survey/survey-sections-rendering-components/SurveySection";


type ParagraphComponentProps = {
  title: SurveySectionRenderingComponent;
  surveySectionRenderingModel: SurveySectionsRenderingModel | null;
  defaultTitleClass: string;
}

export default function ParagraphPageComponent({title, surveySectionRenderingModel, defaultTitleClass}: ParagraphComponentProps) {
  const renderedTitle = <TitleComponent title={title} surveySectionRenderingModel={surveySectionRenderingModel} defaultTitleClass={defaultTitleClass} />;
  return (typeof title === "string") ? (
          <p className={"my-4"}>
            {renderedTitle}
          </p>
      ) :
      renderedTitle
}
